import React from 'react';
import SessionAuthForm from './Auth/Form/SessionAuthForm';
import { t } from '../shared/i18n/util';
import {
  AuthContainer,
  AuthFormContainer,
  AuthFormMainTitle,
  AuthFormNewAccount,
  AuthFormRegister,
  AuthFormTitle
} from './styles';
import logo from '../images/logos/logo.svg';

const Auth = () => (
  <AuthContainer {...{ logo }}>
    <AuthFormContainer>
      <AuthFormMainTitle>{t('labelWelcome')} </AuthFormMainTitle>
      <AuthFormMainTitle color="#1168a8">{t('labelMuucontrol')}</AuthFormMainTitle>
      <AuthFormTitle>{t('labelAuthSubtitle')}</AuthFormTitle>
      <div style={{ marginTop: '20px' }}>
        <SessionAuthForm />
      </div>
      <AuthFormNewAccount>
        {t('labelNotAccount')}
        {', '}
        <AuthFormRegister>{t('labelSignUp').toUpperCase()}!</AuthFormRegister>
      </AuthFormNewAccount>
    </AuthFormContainer>
  </AuthContainer>
);

export default Auth;
